import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LanguageSelectionComponent } from './language-selection/language-selection.component';
import { QRProductScanComponent } from './qr-product-scan/qr-product-scan.component';

// Custom matcher to match 'IN/qr/<id>' with slashes or encoded values
export function qrMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length >= 3 && segments[0].path === 'IN' && segments[1].path === 'qr') {
    const id = segments.slice(2).map(s => s.path).join('/');
    return {
      consumed: segments,
      posParams: {
        id: new UrlSegment(id, {})
      }
    };
  }
  return null;
}

const routes: Routes = [
  {
    path: '',
    component: ErrorPageComponent
  },
  {
    matcher: qrMatcher,
    component: QRProductScanComponent
  },
  {
    path: 'IN/qr',
    component: ErrorPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'I',
    component: QRProductScanComponent,
    pathMatch: 'full'
  },
  {
    path: 'I/:id',
    component: QRProductScanComponent,
    pathMatch: 'full'
  },
  {
    path: 'error-page',
    component: ErrorPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'language-selection',
    component: LanguageSelectionComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
